import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageLayout from '../components/global/PageLayout';
import { decryptId } from '../components/common/Encryption/encryption';
import BreakoutRooms from '../components/BreakoutRooms';

// cw: full-page view for Zoom breakout rooms, mirroring the ConnectMeet /groupsDetail
// page. Reached from an event's "Generate Zoom Breakouts" button.
const BreakoutDetail = () => {
    const { eventid } = useParams();
    const [id, setId] = useState(null);
    const history = useNavigate();

    useEffect(() => {
        if (eventid) decryptId(eventid).then(decrypted => setId(decrypted));
    }, [eventid]);

    return (
        <PageLayout>
            <div className="bg-white border-gray-200 px-4 pt-8 lg:px-6 py-2.5 dark:bg-gray-800">
                <div className="container mx-auto">
                    <div
                        className="mb-4 pt-1  pointer"
                        onClick={() => history(-1)}
                    >
                        <span>
                            <i className="fa fa-arrow-left mr-2"></i>
                        </span>
                        Back
                    </div>
                    <h3 className="text-2xl font-semibold text-[#111827] mb-1">Zoom Breakout Rooms</h3>
                    {id && <BreakoutRooms eventId={id} isLeader={true} />}
                </div>
            </div>
        </PageLayout>
    );
};

export default BreakoutDetail;
